<template>
    <div class="search-field-wrapper" :class="{ '_disabled' : loading }">
        <input
            type="text"
            :placeholder="'Search'"
            :value="value"
            @keydown="onKeyDown($event)"
            @input="input($event.target.value)"
            autofocus
            id="input"
            ref="searchInput"
        >

        <div class="icon">
            <img src="@/assets/img/icon/ic_search.png" @click="$refs.searchInput.focus()">
        </div>
    </div>
</template>
<script>
export default {
	props: {
		value: {
			type: String,
			default: ''
        },
        
        loading: {
            type: Boolean,
			default: false
        }
	},

	methods: {
        onKeyDown (event) {
            if (this.loading) {
                event.preventDefault()
            }
        },

		input (keyword) {
			clearTimeout(this.timeout)

			this.timeout = setTimeout(() => {
				this.$emit('input', keyword)
			}, 500)
		}
	}
}
</script>

<style lang="scss" scoped>
.search-field-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #FFFFFF;
    border: 1px solid #D9DEE2;
    border-radius: 7px;
    width: 100%;
    max-width: 300px;

    input {
        flex: 1 1 auto;
        background-color: #FFFFFF;
        border-radius: 7px;
        border: none;
        padding: 7px 10px;
        font-size: 1rem;
        color: #4A4C50;

        &::placeholder {
            font-style: italic;
            font-size: 14px;
            color: #979CAC;
        }
    }

    .icon {
        padding-right: 15px;
        // pointer-events: none;
        cursor: pointer;

        img {
            width: 15px;
        }
    }
}
</style>
